import { DRIVER } from '@/constants/api-types'
import ApiCore from './api-core'

export default class Credential extends ApiCore {
  constructor(store) {
    const path = `${DRIVER}/credential`
    super(store, path)
  }

  report(filter, showProgress) {
    return this.request({
      action: 'report',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  list(filter, showProgress) {
    return this.request({
      action: 'list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  update(id, model, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'PUT',
      body: model,
      showProgress
    })
  }

  create(data, showProgress) {
    return this.request({
      action: 'create',
      method: 'POST',
      body: data,
      showProgress
    })
  }

  get(id, showProgress) {
    return this.request({
      action: `${id}`,
      method: 'GET',
      showProgress
    })
  }

  deleteSession(id, showProgress) {
    return this.request({
      action: `session/${id}`,
      method: 'DELETE',
      showProgress
    })
  }
}
